export class PrestacionPreparacion {
  private preparacion: string;
  private prestaciones: string;
  private idPreparacion: number;
  private descripcion: string;

  constructor(
    preparacion: string,
    prestaciones: string,
    idPreparacion: number,
    descripcion: string
  ) {
    this.preparacion = preparacion;
    this.prestaciones = prestaciones;
    this.idPreparacion = idPreparacion;
    this.descripcion = descripcion;
  }

  // Getters y Setters
  public getPreparacion(): string {
    return this.preparacion;
  }

  public setPreparacion(preparacion: string): void {
    this.preparacion = preparacion;
  }

  public getPrestaciones(): string {
    return this.prestaciones;
  }

  public setPrestaciones(prestaciones: string): void {
    this.prestaciones = prestaciones;
  }

  public getIdPreparacion(): number {
    return this.idPreparacion;
  }

  public setIdPreparacion(idPreparacion: number): void {
    this.idPreparacion = idPreparacion;
  }

  public getDescripcion(): string {
    return this.descripcion;
  }

  public setDescripcion(descripcion: string): void {
    this.descripcion = descripcion;
  }

  // Método estático para mapear una colección de objetos de la API a PrestacionPreparacion
  public static fromCollection(apiData: any[]): PrestacionPreparacion[] {
    return apiData.map(
      (item) =>
        new PrestacionPreparacion(
          item.preparacion,
          item.prestaciones,
          item.id_preparacion,
          item.descripcion
        )
    );
  }

  // Método toString para representar el objeto como una cadena de texto
  public toString(): string {
    return `Preparación: ${this.preparacion}, Prestaciones: ${this.prestaciones}, ID Preparación: ${this.idPreparacion}, Descripción: ${this.descripcion}`;
  }
}
